import { createSlotRecipe } from './runtime';

const selectionConfig = {"name":"selection","slots":["control","indicator"]}

export const selection = /* @__PURE__ */ createSlotRecipe(selectionConfig)